module.exports = __webpack_public_path__ + "images/Banner-ced3383e50c8658006275dcf69f5074b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Banner.jpg
// module id = 19
// module chunks = 0